export const convertBooleanChoiceToString = (
  choice: boolean | null
): string => {
  if (choice === null) return 'None provided'

  return choice ? 'Yes' : 'No'
}
